module.exports = __webpack_public_path__ + "img/nature42.2ff44e4e.jpg";